var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcViewDiagonalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "top/Arrow/Property 25 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C2 0.447715 2.44772 0 3 0H11C11.5523 0 12 0.447715 12 1V9C12 9.55229 11.5523 10 11 10C10.4477 10 10 9.55229 10 9V3.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L8.58579 2H3C2.44772 2 2 1.55228 2 1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewDiagonalArrow);
export default __webpack_public_path__ + "static/media/ic_view_diagonal_arrow.5466981905140df19d9c6edce0350012.svg";
export { ForwardRef as ReactComponent };